import { initialState } from './reducer';

export const selectIsLoading = (state = initialState) => state.isLoading;
